import React, { Component, Fragment, useState } from 'react';
import Login from './loginComp';
import RegisterComp from './registerComp';
import APP from 'app';

const { Utils } = APP, { translateText } = Utils;

const RightSide = (props) => {
    const { translationId = '' } = props;
    const [openRegister, setOpenRegister] = useState(false);
    return (
        <div className="b2c__loginwrap--rightside">
            <form>
                {!openRegister ?
                    <Login {...props} />
                    :
                    <RegisterComp
                        {...props}
                        openRegisterHandler={() => { setOpenRegister(!openRegister) }}
                    />
                }

                <p className="b2c__loginwrap--or">{translateText('or', translationId)}</p>
                <p className="b2c__loginwrap--createAccount">
                    {!openRegister ?
                        <Fragment>
                            {translateText('dontHaveAnAccount', translationId)}
                            <span
                                className="b2c__loginwrap--createlink"
                                onClick={() => { setOpenRegister(!openRegister) }}
                            >
                                {translateText('createAnAccount', translationId)}
                            </span>
                        </Fragment>
                        :
                        <Fragment>
                            {translateText('alreadyHaveAnAccount', translationId)}
                            <span
                                className="b2c__loginwrap--createlink"
                                onClick={() => { setOpenRegister(!openRegister) }}
                            >
                                {translateText('signIn', translationId)}
                            </span>
                        </Fragment>}
                </p>
            </form>
        </div>
    )
}

export default RightSide;